function BrandStatus() {

    return(
        <div className="brand-status-root">
            brand status coming soon
        </div>
    )
}
export default BrandStatus